<template>
  <div
    :class="[
      'h-15 bg-background relative flex w-full items-center justify-between py-3',
    ]"
  >
    <div
      class="ml-3 flex h-full items-center justify-center"
    >
      <BaseToggle
        :model-value="modelValue"
        :disabled="disabled"
        @update:model-value="handleToggleUpdate"
      />
    </div>
    <div class="ml-3 flex-1">
      <p class="line-clamp-1 text-left text-sm font-medium">
        <slot name="label">
          {{ label }}
        </slot>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string
  modelValue: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()

const handleToggleUpdate = (value: boolean) => {
  emit("update:modelValue", value)
}
</script>
